import React from "react";
import { Link } from "react-router-dom";

import ReportActions from "../ReportActions";
import ReportStatus from "../ReportStatus";
import { useReport, useReportCatalog } from "../api";
import AcademyRosterReport from "../renderers/AcademyRosterReport";
import { LegalFooter } from "../renderers/AthleteReports";
import { usePeriodParam } from "../usePeriodParam";

const detailPath = (athleteId) => `/scout/reportes/${athleteId}`;

/**
 * /scout/reportes — the coach's group report. Only a scout whose academy is
 * verified coaches a roster; everyone else can still open any athlete's
 * external report from the athlete list.
 */
const ScoutReportsPage = () => {
  const [days, setDays] = usePeriodParam();
  const params = { days };
  const catalog = useReportCatalog();
  const isCoach = Boolean(catalog.data?.some((entry) => entry.id === "academy-roster"));
  const query = useReport("academy-roster", params, { enabled: isCoach });

  if (catalog.isLoading || catalog.isError) {
    return (
      <div className="flex flex-1 flex-col overflow-y-auto bg-paper">
        <ReportStatus query={catalog} />
      </div>
    );
  }

  if (!isCoach) {
    return (
      <div className="flex flex-1 flex-col overflow-y-auto bg-paper">
        <div className="flex flex-1 flex-col items-center justify-center gap-3 px-6 py-20 text-center">
          <p className="font-display text-3xl font-semibold text-navy-900">Reportes</p>
          <p className="max-w-md text-sm text-ink">
            El reporte de grupo es para entrenadores con una academia verificada. Puedes ver el reporte de rendimiento y
            disponibilidad de cualquier deportista desde su ficha.
          </p>
          <Link
            to="/scout/athletes"
            className="rounded-lg bg-navy-900 px-4 py-2 text-sm font-semibold text-white hover:bg-navy-700"
          >
            Ir a la lista de atletas
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col overflow-y-auto bg-paper">
      <ReportActions
        title="Mis deportistas"
        reportId="academy-roster"
        reportTitle="Reporte de grupo"
        params={params}
        period={days}
        onPeriodChange={setDays}
      />
      {query.data ? (
        <>
          <main className="mx-auto w-full max-w-[1180px] px-4 pt-5 pb-6 sm:px-5">
            <AcademyRosterReport data={query.data.data} detailPath={detailPath} />
          </main>
          <LegalFooter />
        </>
      ) : (
        <ReportStatus query={query} />
      )}
    </div>
  );
};

export default ScoutReportsPage;
